import { useEffect, useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'

export const loadAllContracts = () => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const { getUnitId } = useLocalStorage()

  const { httpClientPost } = useRemoteClientPost()
  const reloadTemplates = () => load()

  const load = () => {
    if (!loading) {
      setLoading(true)
      httpClientPost(`/contratos/filtro?page=0&size=100000`, {
        idUnidade: getUnitId()
      })
        .then((response) => {
          setData(
            response.data.data.content.map((item: any) => ({
              ...item,
              label: item.nome,
              value: item.id.toString()
            }))
          )
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }

  useEffect(() => {
    load()
  }, [])

  return {
    load,
    reloadTemplates,
    data
  }
}
